import { appConfig } from '@/config/app-config';

/* eslint-disable @typescript-eslint/no-explicit-any */
import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import BPCApiServiceInstance from '@core/services/bpc-api-service.instance';
import {
  MobileBookingDTO,
  MobileSubscriptionDTO,
} from '@accounting/interfaces/fallback-mobile-app-payment';

export default class MobileShoppingCartService {
  constructor(
    protected $routeHelper: BPCApiRouteHelper,
    protected $bpcApi: BPCApiServiceInstance,
  ) {}

  public async checkStripeSession(tenantId: number, id: string): Promise<Record<string, any>> {
    console.log(tenantId, id);
    const path = `${tenantId}/raw/mobile-payments/stripe/checkout/${id}`;
    const response = await this.$bpcApi.get(path).toPromise();
    return response.data;
  }

  public async fetchSubscriptionDetails(
    tenantId: number,
    productId: string,
  ): Promise<MobileSubscriptionDTO> {
    console.log(tenantId, productId);
    const path = `${tenantId}/raw/mobile-payments/subscriptions/${productId}`;
    const response = await this.$bpcApi.get(path).toPromise();
    return response.data;
  }
  public async fetchBookingDetails(tenantId: number, productId: string): Promise<MobileBookingDTO> {
    const path = `${tenantId}/raw/mobile-payments/bookings/${productId}`;
    const response = await this.$bpcApi.get(path).toPromise();
    return response.data;
  }
}

export const useMobileShoppingCartService = (): MobileShoppingCartService => {
  return new MobileShoppingCartService(
    new BPCApiRouteHelper(),
    new BPCApiServiceInstance({ apiPath: appConfig.apiPathV2 }),
  );
};
